export const UPDATE_ETA_BOTTOM_SHEET_SOURCE = {
  WORKPLACE_CHAT: "WORKPLACE_CHAT",
  SHIFT_DETAILS: "SHIFT_DETAILS",
  DEEP_LINK: "DEEP_LINK",
  UPDATE_ETA_BOTTOM_SHEET_NUDGE: "UPDATE_ETA_BOTTOM_SHEET_NUDGE",
  EDIT_ETA_AFTER_CONFIRMATION: "EDIT_ETA_AFTER_CONFIRMATION",
} as const;

export type UpdateEtaBottomSheetSource =
  (typeof UPDATE_ETA_BOTTOM_SHEET_SOURCE)[keyof typeof UPDATE_ETA_BOTTOM_SHEET_SOURCE];
